// src/components/froggerAI/FroggerDockButton.jsx
//
// The navbar's way into the dock (I-03 R6 · S3-06.3).
//
// It fires an EVENT rather than holding the dock's state, because the
// two live in different subtrees — the navbar is inside the app shell's
// header, the dock is a sibling of <main> — and lifting `open` to a
// third context so a button could set it would put the dock's state
// somewhere neither the dock nor the button lives. One `CustomEvent` on
// `window`, which is the same channel Tasks Today's "Walk me through it"
// already uses to hand the dock a turn.
//
// THE DOCK'S OWN ROUTES ONLY — `froggerDockFacilityId`, the ONE predicate
// the dock mounts on (facility AND my-store pages since Fable ruling R4,
// 2026-10-07; this used to be a second regex that knew only
// `/facilities/`) — and DESKTOP only (the phone dock is always on
// screen and needs no launcher) — the width half is CSS, in navbar.css,
// so a rotation does not have to re-render the navbar to be right.
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Bot } from 'lucide-react';
import { TOGGLE_EVENT } from './FroggerDock';
import { froggerDockFacilityId } from '../layout/dockRoutes';

const OPEN_ATTR = 'data-frogger-dock-open';
const dockIsOpen = () => (typeof document !== 'undefined'
  && document.documentElement.getAttribute(OPEN_ATTR) === '1');

export default function FroggerDockButton() {
  const { pathname } = useLocation();
  // Design System v1 review S5: the toggle SAYS whether the dock is open.
  // FroggerDock owns that state and publishes it as html[data-frogger-
  // dock-open] (which navbar.css also reads for the accent fill), so the
  // button reads the same attribute rather than holding a second copy.
  const [open, setOpen] = useState(dockIsOpen);
  useEffect(() => {
    if (typeof MutationObserver === 'undefined') return undefined;
    const observer = new MutationObserver(() => setOpen(dockIsOpen()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: [OPEN_ATTR] });
    setOpen(dockIsOpen());
    return () => observer.disconnect();
  }, []);
  if (froggerDockFacilityId(pathname) === null) return null;

  return (
    <button
      type="button"
      className="ff-btn ff-btn--ghost ff-btn--icon me-2 nav-icon-btn frogger-dock-btn"
      onClick={() => window.dispatchEvent(new CustomEvent(TOGGLE_EVENT))}
      aria-label="FroggerAI (backtick key)"
      aria-pressed={open}
      data-tooltip="FroggerAI — ask, record, get around (` key)"
      data-frogger-dock-toggle="1"
    >
      <Bot size={18} />
    </button>
  );
}
